import React from 'react';

const DeliveryContext = React.createContext(undefined);

export default DeliveryContext;
